var _toConsumableArray = require("/builds/SocialGouv/legi-detect/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _require = require("./detect.articles"),
    detectSingle = _require.detectSingle,
    detectMultiples = _require.detectMultiples;

var detect = function detect(str, defaultCode) {
  return [].concat(_toConsumableArray(detectSingle(str, defaultCode)), _toConsumableArray(detectMultiples(str, defaultCode)));
};

module.exports = detect;